export default __webpack_public_path__ + "static/media/19.b7eb2960.jpeg";